'use client';
import Image from 'next/image';
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm';

export default function ForgotPasswordPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="w-full max-w-md rounded-lg bg-popover/70 backdrop-blur-md p-8 shadow-lg">
        <div className="mb-6 text-center">
          <Image
            src="/logo.svg"
            alt="Smart Taurus Logo"
            width={200}
            height={60}
            className="mx-auto mb-6 object-contain"
          />
          <p className="mt-2 text-black">
            Forgot your password? Enter your email below to receive a reset link.
          </p>
        </div>
        <ForgotPasswordForm />
      </div>
    </div>
  );
}